<p>The Bid Calendar shows your potential class schedule.</p>
<p>If more than one type of bid is available, buttons will appear allowing you to filter your bids.</p> 
